/**
 * Splits contests into ongoing and upcoming
 * @param {Array} contests - Array of contest objects with start_date and end_date
 * @returns {Object} { ongoing: [...], upcoming: [...] }
 */
export function splitContests(contests) {
  const now = new Date();

  const ongoing = [];
  const upcoming = [];  
  
  contests.forEach(contest => {
    const start = contest.contest.start_date;
    const end = contest.contest.end_date;
    
    if (start <= now && now <= end) {
      ongoing.push(contest);
    } else if (start > now) {
      upcoming.push(contest);
    }
  });

  return { ongoing, upcoming };
}

/**
 * Filters contests by organization id.
 * @param {Array} contests - Array of contest objects with organization id 'org_id'
 * @param {int} org_id - Organization id to filter by
 * @returns {Array} { filtered: [...] }
 */
export function filterContests(contests, org_id) {
  return contests.filter((contest) => contest.contest.org_id == org_id);
}
